import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import {
  DataServiceListParamsInfoModel,
  HttpParamsDataList,
} from '../models/data-service.model';

@Injectable({
  providedIn: 'root',
})
export class ListService {
  protected loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  protected totalCountSubject = new BehaviorSubject<number | undefined>(
    undefined
  );
  public totalCount$ = this.totalCountSubject.asObservable();

  protected getParams(
    dataServiceListModel?: DataServiceListParamsInfoModel
  ): HttpParams {
    let params = new HttpParams();

    if (!dataServiceListModel) {
      return params;
    }

    if (dataServiceListModel.searchParams) {
      dataServiceListModel.searchParams.forEach(
        (searchParam: HttpParamsDataList) => {
          params = params.append(searchParam.param, searchParam.value);
        }
      );
    }

    params = params.append(
      'page',
      dataServiceListModel.page ? dataServiceListModel.page.toString() : 1
    );

    params = params.append(
      'pageSize',
      dataServiceListModel.pageSize
        ? dataServiceListModel.pageSize.toString()
        : 10
    );

    if (dataServiceListModel.search) {
      params = params.append('search', dataServiceListModel.search);
    }

    return params;
  }
}
